import * as yup from 'yup'

export const credentialsValidationSchema = yup.object().shape({
  mail: yup.string().required(),
  password: yup.string(),
  newPassword: yup.string(),
  confirmNewPassword: yup.string().oneOf([yup.ref('newPassword')], 'Passwords must match'),
})

export type CredentialsSchemaType = {
  mail: string
  password: string
  newPassword: string
  confirmNewPassword: string
}

export const credentialsInitialValues = {
  mail: '',
  password: '',
  newPassword: '',
  confirmNewPassword: '',
}
